import { gql } from '@apollo/client'

const updateVirtualModule = gql(`
  mutation updateVirtualModule ( $id: ID, $title: String!, $assetTypes: [String], $isActive: Boolean, $isArchived: Boolean,  $project: String! ) {
    updateVirtualModule (id: $id, title: $title, assetTypes: $assetTypes, isActive:$isActive, isArchived: $isArchived, project: $project) {
      id
      title
      }
  }`)

export default updateVirtualModule
